import { CounterBadge } from '@/components/ui/CounterBadge/CounterBadge';
import clsx from 'clsx';

export interface IconActionButtonProps {
  icon: React.ReactNode;
  btnClass: string;
  hasContent: boolean;
  isLoading?: boolean;
  disabled?: boolean;
  newCount?: number;
  newCountAriaLabel?: string;
  ariaLabel: string;
  onClick: (anchorEl: HTMLElement) => void;
}

export function IconActionButton({
  icon,
  btnClass,
  hasContent,
  isLoading = false,
  disabled = false,
  newCount = 0,
  newCountAriaLabel,
  ariaLabel,
  onClick,
}: IconActionButtonProps) {
  const isDisabled = isLoading || disabled;
  return (
    <span className="projects-table__notes-btn-wrap">
      <button
        type="button"
        className={clsx(
          'projects-table__action-btn',
          btnClass,
          hasContent && 'projects-table__action-btn_has-content',
          isLoading && 'projects-table__action-btn_loading'
        )}
        onClick={(e) => {
          e.stopPropagation();
          if (isDisabled) return;
          onClick(e.currentTarget);
        }}
        aria-label={isLoading ? `${ariaLabel}. Загрузка` : ariaLabel}
        aria-busy={isLoading}
        disabled={isDisabled}
      >
        {isLoading ? <span className="projects-table__action-btn-spinner" aria-hidden="true" /> : icon}
      </button>
      {newCount > 0 && newCountAriaLabel && (
        <CounterBadge size="xs" variant="new" visible aria-label={`${newCountAriaLabel}: ${newCount}`} />
      )}
    </span>
  );
}
